import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {appHeader_template} from "../components/templates/appHeader_template";
import {vnApp_pubinsights} from "../components/vnApp_pubinsights";

declare var page: any;
declare var ko: any;

export class header extends vnModule_knockoutJS{

    protected getModuleName(){
        return "header";
    }

    public appHeader: appHeader_template;
    protected XHRHdl: XMLHttpRequestHandler;

    buildContent() : Array<Element>{

        let vnApp : vnApp_pubinsights = <vnApp_pubinsights>this.getVnAppZone().app;

        if(vnApp.loggedUser.isLoggedIn) {

            this.appHeader = new appHeader_template("mainHeader", this.viewModel, this);

            this.appHeader.setUser(vnApp.loggedUser);

            if(vnApp.isOfRole(vnApp_pubinsights.ROLE_NAME_ADMINISTRATOR) || vnApp.isOfRole(vnApp_pubinsights.ROLE_PRODUCT_MANAGER)){

                this.appHeader.setIsGoalsVisible(true);
                this.appHeader.setIsGroupsVisible(true);
            }
            // set picture
            if (vnApp.loggedUser.user.vnAppUser.pictureUrl) {
                this.appHeader.setUserImageSrc("/usersImages/" + vnApp.loggedUser.user.pictureUrl);
            }
            else {
                this.appHeader.setUserImageSrc("/assets/images/default-user.png");
            }

            // set full name
            this.appHeader.setUserFullName(vnApp.loggedUser.user.vnAppUser.firstName + ' ' + vnApp.loggedUser.user.vnAppUser.lastName);

            // set profile page link
            this.appHeader.setProfilePageLink("/users/edit/" + vnApp.loggedUser.user.id);

            if(this.isOfRole(vnApp_pubinsights.ROLE_NAME_ADMINISTRATOR)){
                this.appHeader.setIsRolesVisible(true);
            }

            return [this.appHeader.build()]
        }else {
            return [];
        }
    }

    public fillPage() : void{
        // this.getUserStats();
    }

    protected getUserStats(){
        // LOADING : starts
        //this.loadingIn(document.getElementById("project-results"));
        let vnApp = this.getVnAppZone().app;

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {
            userId : (vnApp.loggedUser.user ? vnApp.loggedUser.user.id : null)
        };


    }

    public logOut(){
        // loading the page if the user is logged in
        let loginReq_url: string = '/api/access/logout/';
        let loginReq_Params: Array<Array<string>> = [];

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(loginReq_url,loginReq_Params, this);
        XHRHdl.onReadyStateFunction = (function(req, obj){

            return function(){

                if (req.request.readyState == 4) {

                    if(  req.request.status == 200  ){
                        page.redirect('/');
                    }
                }
            }
        });
        XHRHdl.execute();
    }

    public isOfRole(role: Number) {
        let show = false;

        let vnApp = this.getVnAppZone().app;
        let roles: Array<any> = vnApp.loggedUser.user.vnAppUser.roles;
        let roleIds = [];

        for (let role of roles) {
            roleIds.push(role.id);
        }
        if (roleIds.indexOf(role) > -1) {
            show = true;
        }

        return show;
    }

    public setHeaderTitle(title: string){}
}



// WEBPACK FOOTER //
// ./js/modules/header.ts